var module = angular.module('octopusApp.projects');

module.directive('addedHost', function($timeout, octopusLog) {
    return {
        restrict: 'E',
        replace: true,
        templateUrl:'areas/projects/actions/docker_run/added-host.html',
        scope: {
            action: '=',
            project: '=',
            localNames: '='
        },
        controller: function() {
            var vm = this;

            vm.newHost = "";
            vm.newIp = "";
            vm.addNewHost = addNewHost;
            vm.addedHosts = [];
            vm.removeAddedHost = removeAddedHost;

            function addNewHost() {
                if (_.any(vm.addedHosts, function (mapping) {
                        return mapping.ip === vm.newIp;
                    })) {
                    octopusLog.log("Mapping to that container port already exists.. Try again");
                    return;
                }

                var pm = new PortMapping(vm.newHost, vm.newIp, true);
                vm.addedHosts.push(pm);
                vm.newHost = "";
                vm.newIp = "";
                pm.commitEdit();
            }

            function removeAddedHost(mapping){
                var idx = vm.addedHosts.indexOf(mapping);
                if (idx >= 0) {
                    vm.addedHosts.splice(idx, 1);
                }
                setProperties();
            }

            function PortMapping(host, ip) {
                var self = {
                    ip: ip,
                    editIp: ip,
                    host: host,
                    editHost: host,
                    isEditing: false
                };

                self.formatted = formatMapping();
                self.commitEdit = commitEdit;
                self.cancelEdit = cancelEdit;

                function cancelEdit() {
                    self.editIp = self.ip;
                    self.editHost = self.host;
                    self.isEditing = false;
                }

                function commitEdit() {
                    self.ip = self.editIp;
                    self.host = self.editHost;
                    self.isEditing = false;
                    self.formatted = formatMapping();
                    setProperties();
                }

                function formatMapping(){
                    if (!self.host) {
                        // containerPort
                        return self.ip;
                    }
                    return self.host +" : " + self.ip;
                }
                return self;
            }

            function setProperties(){
                vm.action.Properties["Octopus.Action.Docker.AddedHost"] =  JSON.stringify(vm.addedHosts.reduce(function(obj, mapping) {
                    obj[mapping.host] = mapping.ip;
                    return obj;
                }, {}));
            }

            function init() {
                var json = vm.action.Properties["Octopus.Action.Docker.AddedHost"];
                if(!!json) {
                    try {
                        var obj = JSON.parse(json);
                        vm.addedHosts = _.map(obj, function (ip, host) {
                            return new PortMapping(host, ip);
                        });

                    } catch (err) {
                        console.error(err);
                    }
                }
            }

            init();
        },
        controllerAs: 'vm',
        bindToController: true
    };
});




//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/actions/docker_run/added-host.js
// module id = 550103637063400
// module chunks = 1